/* Bisou Rivage — Journal v3 (thème ALT, 15/10/2026).
   Apparitions, titres mot par mot, parallaxe douce, scènes (par étapes ou au défilement), progression, copier le lien, carrousels.
   Les scènes propres à une note s'enregistrent dans window.BJ_HOOKS depuis leur snippet. */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var RM = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var hasIO = 'IntersectionObserver' in w;
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* 1. Apparitions */
  var io = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }) : null;
  function reveal(el) {
    if (el._rv) return; el._rv = 1;
    if (io && !RM.matches) io.observe(el); else el.classList.add('is-in');
  }

  /* 2. Titres : un mot après l'autre (normalement déjà fait par le petit script de la note ; les espaces insécables restent dans le mot) */
  function split(t) {
    if (t._s || t.classList.contains('bj-split')) return; t._s = 1;
    var i = 0;
    t.innerHTML = t.textContent.trim().split(/[ \t\n\r]+/).map(function (x) {
      return '<span class="w"><span style="--i:' + (i++) + '">' + x.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }) + '</span></span>';
    }).join(' ');
    t.classList.add('bj-split');
  }

  /* 3. Une seule boucle : parallaxe, scènes au défilement, progression de lecture */
  var pars = [], scrubs = [], bars = [], steppers = [], ticking = false;
  function frame() {
    ticking = false;
    var vh = w.innerHeight;
    steppers.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      var at = 0;
      for (var k = 0; k < s.marks.length; k++) { if (s.marks[k].getBoundingClientRect().top < vh * 0.58) at = k; }
      if (at !== s.at) s.set(at);
    });
    if (!RM.matches) pars.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) return;
      var c = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      el.style.setProperty('--py', (-c * r.height * 0.06).toFixed(1) + 'px');
    });
    scrubs.forEach(function (s) {
      var r = s.el.getBoundingClientRect(), span = r.height - vh;
      var p = span > 0 ? clamp(-r.top / span, 0, 1) : (r.top < vh / 2 ? 1 : 0);
      if (RM.matches) p = 1;
      if (Math.abs(p - s.p) < 0.0004) return;
      s.p = p;
      s.el.style.setProperty('--p', p.toFixed(4));
      if (s.fn) { try { s.fn(s.el, p); } catch (e) { if (w.console) console.warn('bj scene', e); } }
    });
    bars.forEach(function (b) {
      var a = b.art.getBoundingClientRect();
      b.el.style.setProperty('--p', clamp(-a.top / Math.max(1, a.height - vh), 0, 1).toFixed(4));
    });
  }
  function req() { if (!ticking) { ticking = true; w.requestAnimationFrame(frame); } }
  w.addEventListener('scroll', req, { passive: true });
  w.addEventListener('resize', req);

  /* 4. Scènes par étapes : data-at = la dernière étape dont le texte est passé au-dessus de 58 % de l'écran.
        Calculé à chaque image (un grand coup de pouce ne saute pas d'étape). Au téléphone, le texte de l'étape
        s'affiche sous l'image, dans la partie fixe (.bj-st__cap, copie masquée aux lecteurs d'écran). */
  function steps(sc) {
    if (sc._st) return; sc._st = 1;
    var list = qa('[data-step]', sc), marks = list.map(function (s) { return s.querySelector('.bj-step__t') || s; });
    var vis = sc.querySelector('.bj-st__vis');
    if (vis && !vis.querySelector('.bj-st__cap')) {
      var cap = d.createElement('div'); cap.className = 'bj-st__cap'; cap.setAttribute('aria-hidden', 'true');
      marks.forEach(function (m) { var c = m.cloneNode(true); c.removeAttribute('id'); cap.appendChild(c); });
      vis.appendChild(cap);
    }
    var o = { el: sc, marks: marks, at: -1, fn: (w.BJ_HOOKS || {})[sc.getAttribute('data-steps')] };
    o.set = function (i) {
      o.at = i;
      sc.setAttribute('data-at', i);
      list.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      if (o.fn) { try { o.fn(sc, i); } catch (e) {} }
    };
    o.set(0);
    steppers.push(o);
  }

  /* 5. Copier le lien */
  function copy(b) {
    if (b._c) return; b._c = 1;
    b.addEventListener('click', function () {
      var done = function () { var t = b.textContent; b.textContent = b.getAttribute('data-done') || 'Copié'; setTimeout(function () { b.textContent = t; }, 1800); };
      var u = location.href.split('#')[0];
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(u).then(done, function () {}); else done();
    });
  }

  /* 5 bis. Partager (28/10, journal-perrine-alt) : le partage du téléphone quand il existe ; sinon le bouton reste caché
     (Instagram ne se partage pas depuis le web). */
  function share(b) {
    if (b._sh || typeof navigator.share !== 'function') return; b._sh = 1;
    b.hidden = false;
    b.addEventListener('click', function () {
      var t = d.querySelector('.bj-title');
      navigator.share({ title: t ? t.textContent.replace(/\s+/g, ' ').trim() : d.title, url: location.href.split('#')[0] }).catch(function () {});
    });
  }

  /* 5 ter. Le défilé d'un article (classe bj-defile, articles de Perrine, 28/10) : la piste est doublée pour une boucle
     sans fin (copies cachées aux lecteurs d'écran, alt vide) et un bouton met en pause ou relance. Mouvement réduit
     demandé : rien n'est doublé, la piste se fait défiler au doigt (CSS). */
  function defile(f) {
    if (f._df) return; f._df = 1;
    var p = f.querySelector('.bj-defile__piste');
    if (!p || RM.matches) return;
    qa('img', p).forEach(function (im) {
      var c = im.cloneNode(true);
      c.alt = ''; c.setAttribute('aria-hidden', 'true'); c.removeAttribute('id');
      p.appendChild(c);
    });
    var a = f.closest('.bj'), cap = f.querySelector('figcaption');
    var lp = (a && a.getAttribute('data-bj-pause')) || 'Mettre en pause', ll = (a && a.getAttribute('data-bj-play')) || 'Relancer le défilement';
    var b = d.createElement('button');
    b.type = 'button'; b.className = 'bj-defile__bt'; b.textContent = lp; b.setAttribute('aria-pressed', 'false');
    b.addEventListener('click', function () {
      var on = f.classList.toggle('is-paused');
      b.textContent = on ? ll : lp; b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (!cap) { cap = d.createElement('figcaption'); f.appendChild(cap); }
    cap.appendChild(b);
    f.classList.add('is-loop');
  }

  /* 6. Carrousels */
  function rail(box) {
    if (box._r) return; box._r = 1;
    var track = box.querySelector('[data-track]'), prev = box.querySelector('[data-prev]'), next = box.querySelector('[data-next]');
    if (!track) return;
    /* 25/10/2026 (anglais) : les libellés de la flèche « suivant » viennent de la page (data-lbl-next, sinon son aria-label
       de départ ; data-lbl-bout, posés par bisou-journal-carousel), avec repli sur le français */
    var lNext = next ? (next.getAttribute('data-lbl-next') || next.getAttribute('aria-label') || 'Suivant') : '';
    var lBout = next ? (next.getAttribute('data-lbl-bout') || 'Revenir au début') : '';
    /* 25/10 (animations du Journal) : en mouvement réduit, les flèches sautent d'une carte au lieu de glisser */
    function glisse() { return RM.matches ? 'auto' : 'smooth'; }
    function cellW() { var c = track.querySelector('.bjc__cell'); return c ? c.getBoundingClientRect().width + 18 : 300; }
    function ends() {
      var max = track.scrollWidth - track.clientWidth, x = track.scrollLeft;
      if (prev) prev.toggleAttribute('data-off', x <= 2);
      if (next) next.toggleAttribute('data-off', x >= max - 2);
      /* v5 : au bout d'un rail qui défile, la flèche « suivant » ramène au début (le style du carrousel la retourne) */
      if (next) next.toggleAttribute('data-bout', max > 2 && x >= max - 2);
      if (next && next.classList.contains('bjc__arrow')) next.setAttribute('aria-label', next.hasAttribute('data-bout') ? lBout : lNext);
    }
    if (next) next.addEventListener('click', function () {
      if (next.hasAttribute('data-bout')) track.scrollTo({ left: 0, behavior: glisse() });
      else track.scrollBy({ left: cellW(), behavior: glisse() });
    });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cellW(), behavior: glisse() }); });
    var tk = false;
    track.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(function () { tk = false; ends(); }); } }, { passive: true });
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; track.style.scrollSnapType = 'none'; });
    w.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = sl - dx; });
    w.addEventListener('pointerup', function () { if (!down) return; down = false; track.style.scrollSnapType = ''; });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    qa('a', track).forEach(function (a) { a.addEventListener('dragstart', function (e) { e.preventDefault(); }); });
    w.addEventListener('resize', ends);
    setTimeout(ends, 80); ends();
  }

  /* 7. Rangées au doigt (28/10, tour 16) : la photo de la carte qui entre quand on fait glisser une rangée (« Les dernières
        notes », « À ne pas manquer », les tirages d'une note) n'était demandée qu'à son entrée (loading="lazy") : au téléphone,
        en 4G, la carte restait noire ou vide 0,5 à 1 s. Une fois la page chargée, quand la rangée approche de l'écran, la
        photo de la carte qui suit la dernière visible est demandée d'avance, puis la suivante à chaque carte qui entre :
        toujours une carte d'avance, quelle que soit la largeur des cartes (une marge fixe en demandait deux de plus dans une
        rangée, aucune dans l'autre). Le carrousel des autres pages (.bjc) ne change pas. */
  function ahead(row) {
    if (row._ah || !hasIO) return; row._ah = 1;
    var imgs = qa('img[loading="lazy"]', row);
    if (imgs.length < 2) return;
    var near = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      near.disconnect();
      var io2 = new IntersectionObserver(function (es2) {
        es2.forEach(function (e) {
          if (!e.isIntersecting) return;
          var nx = imgs[imgs.indexOf(e.target) + 1];
          if (nx) nx.loading = 'eager';
          io2.unobserve(e.target);
        });
      }, { root: row });
      imgs.forEach(function (i) { io2.observe(i); });
    }, { rootMargin: '100% 0px' });
    near.observe(row);
  }
  function aheadAll(r) { qa('[data-bjp-scroll], .bj-prods__l', r).forEach(ahead); }

  /* Démarrage */
  function init(r) {
    r = r || d;
    var arts = qa('.bj, .bjx, .bjc', r);
    arts.forEach(function (b) { b.classList.add('bj-js', 'bj-ready'); });
    if (d.querySelector('.bj')) root.classList.add('bj-page');
    qa('.bj-title', r).forEach(split);
    qa('[data-rv]', r).forEach(reveal);
    qa('.bj-par', r).forEach(function (el) { if (pars.indexOf(el) < 0) pars.push(el); });
    var H = w.BJ_HOOKS || {};
    qa('[data-scrub]', r).forEach(function (el) {
      if (el._sc) return; el._sc = 1;
      scrubs.push({ el: el, p: -1, fn: H[el.getAttribute('data-scrub')] });
    });
    qa('[data-steps]', r).forEach(steps);
    qa('.bj-prog', r).forEach(function (el) {
      if (el._b) return; el._b = 1;
      var a = el.closest('.bj'); if (a) bars.push({ el: el, art: a });
    });
    qa('[data-bj-copy]', r).forEach(copy);
    qa('[data-bj-share]', r).forEach(share);
    qa('.bj-defile', r).forEach(defile);
    qa('[data-bj-rail]', r).forEach(rail);
    /* après le chargement : les photos du premier écran passent d'abord */
    if (d.readyState === 'complete') aheadAll(r); else w.addEventListener('load', function () { aheadAll(r); }, { once: true });
    var I = w.BJ_INIT || [];
    I.forEach(function (f) { if (!f._done) { f._done = 1; try { f(); } catch (e) { if (w.console) console.warn('bj init', e); } } });
    req();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
